import * as i0 from "@angular/core";
export class FullYearDateRangeDropdownTextPipe {
    transform(startYear, endYear) {
        if (startYear && endYear) {
            return `${startYear} - ${endYear}`;
        }
        if (startYear) {
            return `${startYear}`;
        }
        return 'Select';
    }
}
FullYearDateRangeDropdownTextPipe.ɵfac = function FullYearDateRangeDropdownTextPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FullYearDateRangeDropdownTextPipe)(); };
FullYearDateRangeDropdownTextPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "fullYearDateRangeDropdownText", type: FullYearDateRangeDropdownTextPipe, pure: true, standalone: false });
